import CuPage from './Cu-Page';
export default CuPage;


// WEBPACK FOOTER //
// ./src/packages/Page/CuPage/index.js